import { render } from "./FamousSwiper.vue?vue&type=template&id=7110f324"
import script from "./FamousSwiper.vue?vue&type=script&lang=js"
export * from "./FamousSwiper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__